<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202412_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202412_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right">肌がキレイな人がやっている<br>スキンケア</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">美しい肌に導くための3箇条<br>「丁寧な洗顔」「保湿」「美肌菌」</h2>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3"><small>こんな人いませんか？</small><br>『いつも肌がキレイな人』</h3>
        <p class="mb-3">友人や職場など、周りに一人はいるかもしれません。</p>
        <p class="mb-3">そんな方がいるとつい<br>『どんなスキンケアをしているの？』<br>と聞きたくなりますよね。</p>
        <p class="mb-3">一般的に私たちが『肌がキレイ』と感じる人の特徴は</p>
        <p class="mb-3">「透明感、ツヤがある」「毛穴が目立たない」「キメが細かい」「シミ・しわがない」などだと思います。</p>
        <p class="mb-3">ぷるっとうるおいを感じる肌は、若々しく健康的で憧れますよね。</p>
        <p>そんな方達は一体どんな「キレイな肌づくり」のために努力をしているのでしょうか。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202412_02.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202412_03.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">『肌がキレイな人』がやっていること</h3>
        <p class="mb-3">10代〜50代の女性500人に「キレイな肌をつくるために努力や工夫していること」を聞いた調査によると（*1）</p>
        <p class="mb-3">圧倒的に<strong>「保湿ケア」</strong>、次いで<strong>「丁寧なクレンジング・洗顔」</strong>という結果に。</p>
        <p class="mb-3">みなさんはこの結果を聞いて「基本だし毎日やっているのに、自分の理想のキレイな肌にならない」という人もいるかもしれません。</p>
        <p class="mb-3">しかしこの基本が大切。</p>
        <p>心当たりがある方は是非一度、基本である「洗顔」と「保湿」に立ち返ることがおすすめです。</p>
      </div>
    </div>
    
    <h2 class="my-5 pt-5">マナビス化粧品が大切にしているのは<br>基本である洗顔と保湿。<br><br>なぜならこのピュアな肌の<br>ベースがあってこそ<br>その後の美容液などの効果が<br>期待できるから。</h2>
    <p class="text-center mb-5 pb-5">今回はそんな美しい肌を目指す方に向けて<br>おすすめアイテムのセット使いを提案します。</p>
    <h3 class="text-center mb-5">STEP1<br>毎日使う「洗い流す」洗顔こそ、こだわりのアイテムを！</h3>
    <div class="feature-row step">
      <div class="step-item step-img"><img src="@/assets/img/column/202412_skinwash.jpg"></div>
      <div class="step-item step-txt text-center">
        <h3><small>BASIC</small><br>薬用スキンウォッシュハーフ</h3>
        <p class="mb-3">【自然の恵みを贅沢に凝縮。感動の洗顔体験】</p>
        <p>17種の植物由来成分を配合し、<br>自然の力をたっぷりと詰め込んだ<br>贅沢な洗顔料。</p>
        <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
        </div>
      </div>
      <div class="step-item step-voice"><img src="@/assets/img/column/202412_skinwash_voice.jpg"></div>
    </div>
    <h3 class="text-center mb-5">STEP2<br>洗顔後の過乾燥を防ぐ「十分な保湿」が明日の肌を変える</h3>
    <div class="feature-row step">
      <div class="step-item step-img"><img src="@/assets/img/column/202412_skinmask.jpg"></div>
      <div class="step-item step-txt text-center">
        <h3><small>BASIC</small><br>薬用スキンマスクハーフ</h3>
        <p class="mb-3">感動の声続々の保湿アイテム。</p>
        <p>洗いたての素肌を包み、<br>うるおし、なめらかにするパック。<br>洗い流せる、やわらかなクリーム状。</p>
        <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
        </div>
      </div>
      <div class="step-item step-voice"><img src="@/assets/img/column/202412_skinmask_voice.jpg"></div>
    </div>
    <h3 class="text-center mb-5">STEP3<br>洗い立てのピュアな肌に「美肌菌」を馴染ませる。</h3>
    <div class="feature-row step">
      <div class="step-item step-img"><img src="@/assets/img/column/202412_firstserum.jpg"></div>
      <div class="step-item step-txt text-center">
        <h3><small>FROLA</small><br>フローラ ファーストセラム</h3>
        <p class="mb-3">マスクの後に、まずこれを。</p>
        <p>すこやかさのカギを握る美肌菌と<br>皮膚常在菌のバランスに着目した、<br>洗顔後すぐに使う美肌菌に特化した美容液。</p>
        <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
        </div>
      </div>
      <div class="step-item step-voice"><img src="@/assets/img/column/202412_firstserum_voice.jpg"></div>
    </div>
    <h3 class="text-center mb-5">STEP4<br>「女神オイル」で、さらなる輝きをプラス。</h3>
    <div class="feature-row step">
      <div class="step-item step-img"><img src="@/assets/img/column/202412_skincareoil.jpg"></div>
      <div class="step-item step-txt text-center">
        <h3><small>FROLA</small><br>フローラ スキンケアオイル</h3>
        <p class="mb-3">SNSで女神オイルと話題。</p>
        <p>植物由来成分配合の美容液層と<br>オーガニック成分４種配合のオイル層。<br>美肌菌に着目した、二層の美容液オイル。</p>
        <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
        </div>
      </div>
      <div class="step-item step-voice"><img src="@/assets/img/column/202412_skincareoil_voice.jpg"></div>
    </div>


    <div class="feature-row ">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202412_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <h3 class="mb-3">美容皮膚科医の90%が推奨する「美肌菌」とは？</h3>
        <p class="mb-3">マナビス化粧品は、美肌菌とも呼ばれる 皮膚常在菌 に着目。</p>
        <p class="mb-3">鏡を見たり、肌にふれたりするだけでは気づきませんが、それは、すこやかさのカギを握る大切な存在なのです。</p>
        <p class="mb-3">また、どのような皮膚常在菌が、どのようにバランスを保っているのか、それぞれの肌で違っていることもわかってきました。</p>
        <p class="mb-3">メイクアップを落とすクレンジングは、必要な皮脂や皮膚常在菌まで取り去ってしまいます。</p>
        <p>また、必要なうるおいをきちんと残すタイプの洗顔料も、皮膚常在菌の一部を洗い流してしまうことがあります。</p>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p>すべてのお客様に</p>
        <p class="mb-3 fs-2">自分の肌を好きでいてほしいから。</p>
        <p class="mb-3">肌の調子がいいと自分に自信が持てたり、<br>化粧ノリがいいと1日が少しハッピーだったり、<br>肌がキレイだと言われるとスキンケアの努力が報われていると自分を褒めたくなる。</p>
        <p class="mb-3">少しづつでも基本のことをコツコツ毎日と積み重ねる。</p>
        <p>明日の私の肌を好きでいるために、頑張るお客様をマナビス化粧品が力になれると嬉しいです。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5 mb-5">こちらのビューティーコラムもおすすめ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/column/column-202308">
          <img src="@/assets/img/column/column_202308.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <h3 class="text-center my-3">知ってほしい、丁寧な洗顔</h3>
          <p>大切なのは「朝晩の洗顔」。<br>そしてもっとも重要な保湿ケア。<br>簡単だけど丁寧なルーティンケアの積み重ね。<br>毎日のケアが未来の美肌を築きます。</p>
          <div class="my-5">
            <router-link to="/column/column-202308" class="btn">
              コラムを読む
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/column/column-202408">
          <img src="@/assets/img/column/column_202408-2.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <h3 class="text-center my-3">美肌に欠かせない「美肌菌」</h3>
          <p>美容皮膚科医の90%が推奨する「美肌菌」とは？<br>美肌に欠かせないと最近話題の「美肌菌」。<br>気になるポイントや効果、<br>必要性にについてもご紹介します。</p>
          <div class="my-5">
            <router-link to="/column/column-202408" class="btn">
              コラムを読む
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/column/column-202306">
          <img src="@/assets/img/column/column_202306-2.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <h3 class="text-center my-3">「インバスケア」で保湿革命</h3>
          <p>美容の新習慣。<br>毎日のスキンケアを万全にするためにも、<br>マナビス化粧品はお風呂の中で十分なスキンケアを行う<br>「インバスケア」を提案します。</p>
          <div class="my-5">
            <router-link to="/column/column-202306" class="btn">
              コラムを読む
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="layer_02">
      <img src="@/assets/img/column/202412_05.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left">BASIC</h2>
          <p>すこやかな素肌のためのベーシックケア</p>
        </div>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">BASICシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_basic_01.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">インバスケアセット【クレンジングオイル＋ウォッシュ＆マスク 各ハーフサイズ＋ 泡立てネット】（約1ヶ月分）</div>
              <div class="feature-row_product_cate">BASIC</div>
              <div class="feature-row_product_price">¥8,910</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_basic_02.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">【新商品】マナビス スキンクレンジングオイル</div>
              <div class="feature-row_product_cate">BASIC</div>
              <div class="feature-row_product_price">¥2,970</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_basic_03.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">薬用スキンウォッシュ ハーフ（約1ヶ月分）</div>
              <div class="feature-row_product_cate">BASIC</div>
              <div class="feature-row_product_price">¥2,970</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_basic_04.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">薬用スキンマスク ハーフ（約1ヶ月分）</div>
              <div class="feature-row_product_cate">BASIC</div>
              <div class="feature-row_product_price">¥2,970</div>
            </div>
        </router-link>
      </div>
    </div>
   
    <div class="layer_03">
      <img src="@/assets/img/column/202412_06.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left">FLORA</h2>
          <p>菌に着目したバランシングケア</p>
        </div>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">FLORAシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_flora_01.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">フローラ ファーストセラム</div>
              <div class="feature-row_product_cate">FLORA</div>
              <div class="feature-row_product_price">¥7,700</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_flora_02.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">フローラ スキンケアオイル</div>
              <div class="feature-row_product_cate">FLORA</div>
              <div class="feature-row_product_price">¥7,700</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_flora_03.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">マナビス フローラ サプリメント プラス</div>
              <div class="feature-row_product_cate">FLORA</div>
              <div class="feature-row_product_price">¥6,300</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/202412_flora_04.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">美肌菌トライアルセット【ファーストセラム＋スキンケアオイル】（約7日分）</div>
              <div class="feature-row_product_cate">FLORA</div>
              <div class="feature-row_product_price">¥3,000</div>
            </div>
        </router-link>
      </div>
    </div>

    <div>
      <font size="1">
        *1<br>・引用元「レジーナクリニックによる調査」<br><br>・レジーナクリニック（https://reginaclinic.jp/）
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  right: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202412_05.jpg');
      background-size: cover;
      min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202412_06.jpg');
      background-size: cover;
      min-height: 600px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img,.layer_03 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>